import { Component, computed, inject, input, output } from '@angular/core';
import { NzMenuModeType, NzMenuModule } from 'ng-zorro-antd/menu';
import { MenuItem, MenuItemAction } from './menu.types';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RouterModule } from '@angular/router';
import { IconComponent } from "../icon/icon.component";
import { AsyncPipe, NgClass } from '@angular/common';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { AuthService } from '@auth0/auth0-angular';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

@Component({
  imports: [
    NzMenuModule,
    NzIconModule,
    NzToolTipModule,
    RouterModule,
    IconComponent,
    NgClass,
    NzAvatarModule,
    AsyncPipe,
    NzDropDownModule
  ],
  selector: 'ui-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent {
  private readonly auth: AuthService = inject(AuthService);
  user$ = this.auth.user$;
  items = input<MenuItem[]>()
  isCollapsed = input<boolean>(false)
  mode = input<NzMenuModeType>('inline')
  onAction = output<MenuItemAction>()

  menuItems = computed( () => this.items() || []);

  handleLinkAction(action?:MenuItemAction) {
    if(!action?.type) return

    this.onAction.emit({
      type: action.type,
      value: action?.value
    })
  }

  handleSelect(action?: MenuItemAction) {
    action?.type ? this.handleLinkAction(action) : null;
  }
}
